import { Box, Tooltip, Typography } from "@mui/material";
import { WEEKDAYS } from "../format";
import { EMPTY_CELL, SEQUENTIAL } from "../theme";

/** Weekday by hour, darker is busier; every cell names its count on hover. */
export default function Heatmap({ cells, unit }: {
  cells: Array<{ weekday: number; hour: number; count: number }>; unit: string;
}) {
  const counts = new Map<string, number>();
  cells.forEach((c) => counts.set(`${c.weekday}:${c.hour}`, c.count));
  const max = cells.reduce((m, c) => Math.max(m, c.count), 0);
  const colour = (n: number) =>
    n === 0 || max === 0 ? EMPTY_CELL : SEQUENTIAL[Math.min(SEQUENTIAL.length - 1, Math.ceil((n / max) * SEQUENTIAL.length) - 1)];
  const hours = Array.from({ length: 24 }, (_, h) => h);
  return (
    <Box sx={{ overflowX: "auto" }}>
      <Box sx={{ display: "grid", gridTemplateColumns: "40px repeat(24, minmax(14px, 1fr))", gap: "2px", minWidth: 420 }}>
        <span />
        {hours.map((h) => (
          <Typography key={h} variant="caption" color="text.secondary" sx={{ textAlign: "center" }}>
            {h % 6 === 0 ? h : ""}
          </Typography>
        ))}
        {WEEKDAYS.map((day, weekday) => (
          <Box key={day} sx={{ display: "contents" }}>
            <Typography variant="caption" color="text.secondary">{day}</Typography>
            {hours.map((hour) => {
              const n = counts.get(`${weekday}:${hour}`) ?? 0;
              return (
                <Tooltip key={hour} title={`${day} ${hour}:00, ${n} ${unit}`} disableInteractive>
                  <Box sx={{ height: 18, borderRadius: "2px", backgroundColor: colour(n) }} />
                </Tooltip>
              );
            })}
          </Box>
        ))}
      </Box>
    </Box>
  );
}
